import { useLayoutContext } from '@context/LayoutContext';
import { AvTableV2Base, IAvTableV2Base, TableToolbarV2Base, TableToolbarV2BaseProps } from '@fabric-ui/components';
import { Link, useNavigate } from '@utils/AvRouter';
import { FieldFilter } from './FieldFilter';
import AvTable from './Table/AvTable';

export const AvTableController = ({ tableProps, enableV2 }) => {
  if (enableV2) {
    return <AvTableV2 {...tableProps} />;
  }
  return <AvTable {...tableProps} />;
};

export type AvTableV2Props = Omit<IAvTableV2Base, 'onNavigate' | 'localColumnsWidth' | 'onColumnResizeEnd' | 'FieldFilter'>;

export const AvTableV2 = (props: AvTableV2Props) => {
  const navigate = useNavigate();
  const {
    layoutWidths: { [props.storageKey!]: LocalColumnsWidth },
    setLayoutWidths,
  } = useLayoutContext();
  return (
    <AvTableV2Base
      {...props}
      onNavigate={navigate}
      localColumnsWidth={LocalColumnsWidth}
      onColumnResizeEnd={setLayoutWidths}
      FieldFilter={FieldFilter}
    />
  );
};

export type TableToolbarV2Props = Omit<TableToolbarV2BaseProps, 'Link'>;

export const TableToolbarV2 = (props: TableToolbarV2Props) => <TableToolbarV2Base {...props} Link={Link} />;
